import React, { useState } from 'react';
import styles from './Tel.module.css';
import { FormTitle } from '../../../Common/FormTitle';
import { NextButton } from '../../../Common/CtaButton/NextButton';
import { FormField } from '../../../Common/FormField';
import { validatePhoneNumber } from './validate';
import { LeadText } from '../../../Common/LeadText';
import { HandleTelChangeFunction } from './types';

export const Tel = () => {
    const [tel, setTel] = useState('');
    const [lineId, setLineId] = useState('');
    const [telError, setTelError] = useState('');
    const [isFormValid, setIsFormValid] = useState(false);

    const handleTelChange: HandleTelChangeFunction = value => {
        setTel(value);
        const { isValid, error } = validatePhoneNumber(value);
        setTelError(error);
        setIsFormValid(isValid);
    };

    const handleTelBlur = () => {
        const { isValid, error } = validatePhoneNumber(tel);
        setTelError(error);
        setIsFormValid(isValid);
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <div className={styles.monthbox}>
                    <FormTitle
                        formTitleText="連絡先は？"
                        dataViewLabel="EF_連絡先_pv"
                        dataClickLabel="EF_連絡先_戻る"
                    />
                </div>
                <div className={styles.telField}>
                    <FormField
                        label="電話番号"
                        placeholder="09012345678"
                        value={tel}
                        isInputType={'tel'}
                        onChange={handleTelChange}
                        onBlur={handleTelBlur}
                        maxLength={11}
                    />
                    {telError && (
                        <p className={styles.errorMessages}>{telError}</p>
                    )}
                    <LeadText text="ハイフン「-」の入力は不要です" />
                </div>
                <div className={styles.lineField}>
                    <FormField
                        label="LINEID(任意)"
                        placeholder="LINEIDを入力(任意)"
                        value={lineId}
                        onChange={setLineId}
                        onBlur={handleTelBlur}
                    />
                    <LeadText text="無料転職サポートをLINEのやりとりでご希望の方のみ記入" />
                </div>
                <NextButton
                    formKey={['tel', 'lineId']}
                    formValue={[tel, lineId]}
                    displayFormKey={['tel', 'lineId']}
                    displayFormValue={[tel, lineId]}
                    isDisabled={!isFormValid}
                    dataClickLabel="EF_連絡先_次へ"
                />
            </div>
        </div>
    );
};
